module.exports = __webpack_public_path__ + "static/media/Tap.fff4e237.png";